import type { ThemeConfig } from "antd";
import { theme as antdTheme } from "antd";

const primary = "#1677ff";

export const adminFontFamily =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif";

export const monoFontFamily =
  "'JetBrains Mono', Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace";

export function buildAdminTheme(mode: "light" | "dark"): ThemeConfig {
  const reduceMotion =
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  return {
    algorithm:
      mode === "dark" ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
      colorPrimary: primary,
      borderRadius: 6,
      fontFamily: adminFontFamily,
      fontFamilyCode: monoFontFamily,
      motion: reduceMotion ? false : undefined,
    },
    components: {
      Layout: {
        bodyBg: mode === "dark" ? "#0b0e14" : "#f5f6f8",
      },
      Card: {
        paddingLG: 20,
      },
    },
  };
}
